import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import moment from 'moment';
import qs from 'querystringify';
import Layout from '../../../components/global/Layout';
import Header from './Header';
import EventList from './EventList';
import SearchBox from './SearchBox';
import {
  Loading,
  Pagination,
  Table,
  Box,
  // CustomInput,
  // CustomSelect,
} from '../../../components/elements';

const EventsQuery = gql`
  query searchEvents($input: SearchInput) {
    search_events(input: $input) {
      total_pages
      total_size
      event_listing {
        place_id
        event_id
        status
        display_order
        featured
        default_url
        start
        end
        place_name
        venue_name
        name
        description
        tagline
        slug
        listing_type
        voucher_count
        minimum_price
        maximum_price
        address_line_1
        address_line_2
        city
        state
        country
        post_code
        latitude
        longitude
        location
        timezone
      }
    }
  }
`;

const Events = props => {
  const routeState = qs.parse(props.location.search);
  const { event_name, place_name, eventStatus } = routeState;

  const [eventData, setEventData] = useState([]);
  const [sort, setSort] = useState('UPDATED_DESC');
  const [eventNameSort, setEventNameSort] = useState('AES');
  const [placeNameSort, setPlaceNameSort] = useState('AES');
  const [citySort, setCitySort] = useState('AES');
  const [listingTypeSort, setListingTypeSort] = useState('AES');
  const [startDateSort, setStartDateSort] = useState('AES');

  const [status, setStatus] = useState('current');
  //  const [eventStatus, setEventStatus] = useState('ACTIVE');
  const [placeStatus] = useState('ACTIVE');
  const [searchQuery, setSearchQuery] = useState('');
  const [eventNameSearchQuery, setEventNameSearchQuery] = useState('');
  const [searchCity, setSearchCity] = useState('');
  const [placeNameSearchInput, setPlaceNameSearchInput] = useState('');

  const [location, setLocation] = useState('');
  const [draft] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [pageFrom, setPageFrom] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalElements, setTotalElements] = useState();
  const [listSize] = useState(10);

  const [startDateRangeFilter, setStartDateRangeFilter] = useState({
    end_date: moment().format('YYYY-MM-DD'),
  });
  const [endDateRangeFilter, setEndDateRangeFilter] = useState({
    start_date: moment().format('YYYY-MM-DD'),
  });

  const input = {};
  const event_filter = {};
  const place_filter = {};

  Object.assign(input, searchCity !== '' && { location: searchCity });
  Object.assign(place_filter, { status: placeStatus });
  Object.assign(
    event_filter,
    place_name && { place_name },
    event_name && { event_name },
    startDateRangeFilter && {
      start_date_range: startDateRangeFilter,
    },
    endDateRangeFilter && {
      end_date_range: endDateRangeFilter,
    },
    {
      draft,
      listing_type: ['public_tickets', 'private_tickets'],
    },
    { status: eventStatus },
  );
  Object.assign(
    input,
    location !== '' && { location },

    { from: pageFrom, size: listSize },
    { sort },
    searchCity !== '' && { location: searchQuery },
    searchQuery !== '' && { search_criteria: searchQuery },
    event_filter !== {} && {
      filter: {
        event_filter,
        place_filter,
      },
    },
  );

  return (
    <Layout>
      <Header />
      <Box>
        <SearchBox
          searchQuery={searchQuery}
          eventNameSearchQuery={eventNameSearchQuery}
          setEventNameSearchQuery={setEventNameSearchQuery}
          status={status}
          setStatus={setStatus}
          eventStatus={eventStatus}
          // setEventStatus={setEventStatus}
          setLocation={setLocation}
          handleSearchTag={setSearchQuery}
          handleLocation={setSearchCity}
          setStartDateRangeFilter={setStartDateRangeFilter}
          setEndDateRangeFilter={setEndDateRangeFilter}
          placeNameSearchInput={placeNameSearchInput}
          setPlaceNameSearchInput={setPlaceNameSearchInput}
          routeState={routeState}
          event_name={event_name}
          place_name={place_name}
        />
        {totalElements > 0 && (
          <Pagination
            pageFrom={pageFrom}
            pageCount={pageCount}
            listSize={listSize}
            currentPage={currentPage}
            totalElements={totalElements}
            handlePageClick={value => {
              setPageFrom(value.selected * listSize);
              setCurrentPage(value.selected + 1);
            }}
          />
        )}

        <Table>
          <thead>
            <tr>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setEventNameSort(
                          eventNameSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          eventNameSort === 'AES'
                            ? 'EVENT_NAME_DESC'
                            : 'EVENT_NAME_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          eventNameSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Event Name
                  </span>
                  {/* <br />
            <CustomInput /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setPlaceNameSort(
                          placeNameSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          placeNameSort === 'AES'
                            ? 'PLACE_NAME_DESC'
                            : 'PLACE_NAME_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          placeNameSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Place Name
                  </span>
                  {/* <br />
            <CustomInput /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setCitySort(citySort === 'AES' ? 'DES' : 'AES');
                        setSort(
                          citySort === 'AES'
                            ? 'PLACE_CITY_DESC'
                            : 'PLACE_CITY_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          citySort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    City / Suburb
                  </span>
                  {/* <br />
            <CustomInput /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setListingTypeSort(
                          listingTypeSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          listingTypeSort === 'AES'
                            ? 'LISTING_TYPE_DESC'
                            : 'LISTING_TYPE_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          listingTypeSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    Listing Type
                  </span>
                  {/* <br />
            <CustomSelect
              options={[
                { value: '', label: 'Select..' },
                { value: 'APPROVED', label: 'APPROVED' },
                { value: 'UNAPPROVED', label: 'UNAPPROVED' },
              ]}
            /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setStartDateSort(
                          startDateSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          startDateSort === 'AES' ? 'START_DESC' : 'START_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          startDateSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    Start Date
                  </span>
                </div>
              </th>
              {/* <th>
                <div>
                  <span>
                    <i className="fas fa-sort-amount-down" /> Status
                  </span>
                  <br />
                  <CustomSelect
                    options={[
                      { value: '', label: 'Select..' },
                      { value: 'APPROVED', label: 'APPROVED' },
                      { value: 'UNAPPROVED', label: 'UNAPPROVED' },
                    ]}
                  />
                </div>
              </th> */}
            </tr>
          </thead>
          <Query
            query={EventsQuery}
            variables={{ input }}
            fetchPolicy="network-only"
          >
            {({ data, loading, error }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                return 'error';
              }
              const { search_events } = data;
              // const events = search_events.event_listing.filter(
              //   event =>
              //     event.listing_type &&
              //     event.listing_type.length > 0 &&
              //     event.listing_type !== 'public_listing',
              // );

              if (search_events.event_listing.length === 0) {
                return <div>NO RECORDS FOUND</div>;
              }
              return (
                <React.Fragment>
                  <View
                    eventData={eventData}
                    setEventData={setEventData}
                    search_events={search_events}
                    setPageCount={setPageCount}
                    setTotalElements={setTotalElements}
                  />
                </React.Fragment>
              );
            }}
          </Query>
        </Table>
      </Box>
    </Layout>
  );
};

export default Events;

const View = ({
  search_events,
  setPageCount,
  setTotalElements,
  eventData,
  setEventData,
}) => {
  useEffect(() => {
    setPageCount(search_events.total_pages);
    setTotalElements(search_events.total_size);
    if (search_events.event_listing) {
      setEventData(search_events.event_listing);
    }
  }, [search_events.total_pages]);
  return (
    <tbody>
      {eventData.map(event => (
        <tr key={event.event_id}>
          <EventList event={event} />
        </tr>
      ))}
    </tbody>
  );
};
